import React, { useEffect, useState } from 'react';
import oneproofQrBg from 'assets/images/oneproof-qr-bg.png';
import oneproof from 'assets/images/oneproof.svg';
const StickerOnproof = () => {
    const [oneproofRotate, setoneproofRotate] = useState(50);
    const [laoOpacity, setlaoOpacity] = useState(100);
    const [englishOpacity, setenglishOpacity] = useState(0);
    function oneproofAnimate(oneproofRotate) {
        var opacityBoost = 3;
        var croppedRotate = Math.abs(((((oneproofRotate / 100) * opacityBoost + 0.5) % 1) - 0.5) * 2);
        setlaoOpacity(easeInOutQuart(croppedRotate));
        setenglishOpacity(easeInOutQuart(1 - croppedRotate));
    }

    function easeInOutQuart(x) {
        return x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2;
    }
    window.addEventListener('deviceorientation', (event) => {
        // console.log(`${event.alpha} : ${event.beta} : ${event.gamma}`);
        setoneproofRotate((((event.gamma + 90) / 180.0 + ((event.beta + 180) / 360.0) * 2) * 3 * 100) % 100);
        // console.log(oneproofRotate);
    });
    useEffect(() => {
        oneproofAnimate(oneproofRotate);
    }, [oneproofRotate]);
    return (
        <div id="oneproof-qr-wrapper">
            <img
                src={oneproofQrBg}
                id="oneproof-bg"
                name="oneproof-bg"
                style={{ transform: 'translate(-50%, -50%) rotate(' + (oneproofRotate / 200) * 360 + 'deg)' }}
            />
            <div className="content">
                <div class="top">
                    <img src={oneproof} className="logo" />
                    {/* <div className="top-right">
                                                    <span className="text-bg" id="oneproof-engtext">
                                                        Verified
                                                    </span>
                                                </div> */}
                </div>

                <div
                    style={{
                        paddingTop: 5,
                        display: 'block',
                        backgroundColor: 'transparent',
                        margin: '20px 6px 0px 6px'
                    }}
                >
                    <span
                        className="text-bg"
                        id="oneproof-laotext"
                        style={{ fontFamily: 'boonhome-400', opacity: laoOpacity, backgroundPosition: ((oneproofRotate * 3) % 100) + '%' }}
                    >
                        ຢືນຢັນ
                    </span>
                    <span
                        class="text-bg"
                        id="oneproof-engtext"
                        style={{
                            // fontFamily: 'boonhome-400',
                            opacity: englishOpacity,
                            backgroundPosition: ((oneproofRotate * 3) % 100) + '%'
                        }}
                    >
                        Verified
                    </span>
                </div>
            </div>
        </div>
    );
};

export default StickerOnproof;
